import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { RoomElementInteractors } from './interactors';
import { EditRoomElement } from './../cmd/EditRoomElement';
import { RoomElementSnapping } from './RoomElementSnapping';
import { Util } from '../utils/Util';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
export class MoveSpline extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mLengthFeedback = null;
    }
    initialize(pMode, pPointIndex, pRoomElement) {
        this.mMode = pMode;
        this.mPointIndex = pPointIndex;
        this.mRoomElement = pRoomElement;
        this.mCommand = new EditRoomElement(this.mRoomManager, this.mRoomElement);
        this.mRESnapping = new RoomElementSnapping(this.mRoomManager);
        this.mMovePos = new Vector3(0, 0, 0);
        this.mCenter = new Vector3(0, 0, 0);
        this.mSplinePoints = [];
        this.mInitialPointMove = true;
        this.mMoved = false;
        this.mRoomElement.setToolRunning(true);
        this.mRoomElement.setTransformStatus("Transform");
        this.mRoomElement.updateGeometry(false, false);
        this.prepareSnapping();
        this.mRoomManager.TransformShape();
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomElement.setMeshVisibility(1);
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        this.mStartPos = pPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mInitialLineLength = 0;
        if (this.mPointIndex > 0) {
            this.mInitialLineLength = Vector3.Distance(tPoints[this.mPointIndex - 1], tPoints[this.mPointIndex]);
        }
        let tRefPointIdx = this.mRoomElement.RefPointIndices;
        this.mInitialRefPointLength = Vector3.Distance(tPoints[tRefPointIdx.P1], this.mRoomElement.RefPoint);
    }
    updatePointerPosition(pPos) {
        let tREgeo = this.mRoomElement.geometry;
        let tCenter = this.mRoomElement.geometry.center();
        let tPoints = tREgeo.getPoints();
        this.mSplinePoints = tPoints;
        let tscaleFak = this.getScreenScaleFactor(tPoints[0]);
        let tnewPos = this.performSnapping(pPos);
        let tpointsPos = Vector3.TransformCoordinates(tnewPos, this.mRoomElement.transformInverted);
        switch (this.mMode) {
            case MoveSpline.Mode.MovePoint:
                if (this.mInitialPointMove) {
                    this.mInitialPointMove = false;
                    tREgeo.setPoints(this.mSplinePoints);
                    this.mRoomElement.updateGeometry();
                }
                // move first and last point together!
                // closed polygon
                if (((this.mPointIndex == tPoints.length - 1) || (this.mPointIndex == 0)) &&
                    Util.vectorEquals3(tPoints[0], tPoints[tPoints.length - 1], tscaleFak)) {
                    tPoints[tPoints.length - 1] = tpointsPos;
                    tPoints[0] = tpointsPos;
                }
                else
                    tPoints[this.mPointIndex] = tpointsPos;
                this.mSplinePoints = tPoints;
                tREgeo.setPoints(tPoints);
                this.mRoomElement.updateGeometry(false);
                this.mMoved = false;
                break;
            case MoveSpline.Mode.MoveSpline:
                if (this.mInitialPointMove) {
                    this.mInitialPointMove = false;
                }
                this.mMovePos = tnewPos;
                this.mCenter = tCenter;
                this.mRoomElement.setPosition(tnewPos.subtract(tCenter));
                this.mMoved = true;
                break;
            case MoveSpline.Mode.MoveRefPoint:
                let tRefPointIdx = this.mRoomElement.RefPointIndices;
                let tcurrentDir = tpointsPos.subtract(tPoints[tRefPointIdx.P1]).normalize();
                let tnewRefPoint = tPoints[tRefPointIdx.P1].add(tcurrentDir.scale(this.mInitialRefPointLength));
                this.mRoomElement.setRefPoint(tnewRefPoint);
                this.mRoomElement.updateGeometry(false);
                break;
            default:
                break;
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        // re-align spline
        if (!this.mMoved) {
            // center polygon points
            let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
            let tREgeo = this.mRoomElement.geometry;
            let tPoints = tREgeo.getPoints();
            let tpolyCenter = Util.getCenterofPolygon(tPoints);
            let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
            let tcurrPos = this.mRoomElement.position.clone();
            tPoints = Util.centerPolygon(tPoints);
            tREgeo.setPoints(tPoints);
            this.mRoomElement.setTransformStatus("");
            this.mRoomElement.updateGeometry(true, false);
            this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
            // let tREgeo = this.mRoomElement.geometry as Spline;
            // let tmCenter = Util.to3d(tREgeo.getPolygonCenter());
            // let tPoints = tREgeo.getPoints();
            // tPoints = Util.centerPolygon(tPoints);
            // tREgeo.setPoints(tPoints);
            // this.mRoomElement.setTransformStatus("");
            // this.mRoomElement.updateGeometry(true, false);
            // this.mRoomElement.setPosition(tmCenter);
        }
        this.mInitialPointMove = true;
        this.mRoomElement.setToolRunning(false);
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand != null)
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mRoomManager.TransformShape();
                this.mCommand = null;
                this.stop();
            });
    }
    prepareSnapping() {
        super.prepareSnapping();
        this.mRESnapping.prepareSnapping(this.mRoomElement);
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mLengthFeedback = new RoomElementInteractors(this.mRoomManager, this.mRoomElement);
        this.mLengthFeedback.showInteractors(false, true);
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mLengthFeedback != null)
            this.mLengthFeedback.showInteractors(false, true);
    }
    clearFeedback() {
        super.clearFeedback();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.clear();
            this.mLengthFeedback = null;
        }
    }
    getScreenScaleFactor(pPoint) {
        //get screen scale factor
        let tScaleFactor = 1.0;
        if (pPoint != null) {
            let tView = this.mRoomManager.view;
            if (tView != null) {
                let tDist = tView.projectedDistance(pPoint, pPoint.add(tView.cameraControl.right.scale(0.1)));
                tScaleFactor = tDist != null ? 1.0 / tDist : 0.1;
                tScaleFactor *= tView.pixelScaleFactor;
            }
        }
        return tScaleFactor;
    }
    performSnapping(pPos) {
        return (this.mRESnapping.snap(pPos, this.mView));
    }
}
//add nested types
(function (MoveSpline) {
    let Mode;
    (function (Mode) {
        Mode[Mode["MovePoint"] = 0] = "MovePoint";
        Mode[Mode["MoveSpline"] = 1] = "MoveSpline";
        Mode[Mode["MoveRefPoint"] = 2] = "MoveRefPoint";
    })(Mode = MoveSpline.Mode || (MoveSpline.Mode = {}));
})(MoveSpline || (MoveSpline = {}));
